/**
 * @fileoverview gRPC-Web generated client stub for com.livongo.protobuf.grpc.external.food
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.23.1
// source: livongo/protobuf/grpc/external/food/food.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var livongo_protobuf_common_meta_image_pb = require('../../../../../livongo/protobuf/common/meta/image_pb.js')

var livongo_protobuf_common_types_absoluteTimestamp_pb = require('../../../../../livongo/protobuf/common/types/absoluteTimestamp_pb.js')

var teladoc_protobuf_common_user_identity_userId_pb = require('../../../../../teladoc/protobuf/common/user/identity/userId_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.com = {};
proto.com.livongo = {};
proto.com.livongo.protobuf = {};
proto.com.livongo.protobuf.grpc = {};
proto.com.livongo.protobuf.grpc.external = {};
proto.com.livongo.protobuf.grpc.external.food = require('./food_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming,
 *   !proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 */
const methodDescriptor_FoodLogService_CreateFoodLogNonStreaming = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/CreateFoodLogNonStreaming',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming,
  proto.com.livongo.protobuf.grpc.external.food.FoodLog,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.FoodLog)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.createFoodLogNonStreaming =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/CreateFoodLogNonStreaming',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_CreateFoodLogNonStreaming,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.createFoodLogNonStreaming =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/CreateFoodLogNonStreaming',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_CreateFoodLogNonStreaming);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 */
const methodDescriptor_FoodLogService_GetFoodLogHistory = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogHistory',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest,
  proto.com.livongo.protobuf.grpc.external.food.FoodLog,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.getFoodLogHistory =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogHistory',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetFoodLogHistory);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.getFoodLogHistory =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogHistory',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetFoodLogHistory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.FoodLogs>}
 */
const methodDescriptor_FoodLogService_GetFoodLogHistoryAsArray = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogHistoryAsArray',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest,
  proto.com.livongo.protobuf.grpc.external.food.FoodLogs,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.FoodLogs.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.FoodLogs)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FoodLogs>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.getFoodLogHistoryAsArray =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogHistoryAsArray',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetFoodLogHistoryAsArray,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.FoodLogs>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.getFoodLogHistoryAsArray =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogHistoryAsArray',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetFoodLogHistoryAsArray);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 */
const methodDescriptor_FoodLogService_UpdateFoodLog = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpdateFoodLog',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest,
  proto.com.livongo.protobuf.grpc.external.food.FoodLog,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.FoodLog)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.updateFoodLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpdateFoodLog',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_UpdateFoodLog,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.updateFoodLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpdateFoodLog',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_UpdateFoodLog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FoodLogService_DeleteFoodLog = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/DeleteFoodLog',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.deleteFoodLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/DeleteFoodLog',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_DeleteFoodLog,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.deleteFoodLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/DeleteFoodLog',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_DeleteFoodLog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest,
 *   !proto.com.teladoc.protobuf.common.user.identity.UserId>}
 */
const methodDescriptor_FoodLogService_GetExternalUserId = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetExternalUserId',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest,
  teladoc_protobuf_common_user_identity_userId_pb.UserId,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  teladoc_protobuf_common_user_identity_userId_pb.UserId.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.teladoc.protobuf.common.user.identity.UserId)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.teladoc.protobuf.common.user.identity.UserId>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.getExternalUserId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetExternalUserId',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetExternalUserId,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.teladoc.protobuf.common.user.identity.UserId>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.getExternalUserId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetExternalUserId',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetExternalUserId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse>}
 */
const methodDescriptor_FoodLogService_ListRecentFoods = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/ListRecentFoods',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest,
  proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.listRecentFoods =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/ListRecentFoods',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_ListRecentFoods,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.listRecentFoods =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/ListRecentFoods',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_ListRecentFoods);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 */
const methodDescriptor_FoodLogService_GetFoodLogById = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogById',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest,
  proto.com.livongo.protobuf.grpc.external.food.FoodLog,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.FoodLog)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.getFoodLogById =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogById',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetFoodLogById,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.getFoodLogById =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFoodLogById',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetFoodLogById);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus>}
 */
const methodDescriptor_FoodLogService_UpdateFocusSetupViewStatus = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpdateFocusSetupViewStatus',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest,
  proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.updateFocusSetupViewStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpdateFocusSetupViewStatus',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_UpdateFocusSetupViewStatus,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.updateFocusSetupViewStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpdateFocusSetupViewStatus',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_UpdateFocusSetupViewStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility>}
 */
const methodDescriptor_FoodLogService_GetFocusSetupVisibility = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFocusSetupVisibility',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest,
  proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.getFocusSetupVisibility =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFocusSetupVisibility',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetFocusSetupVisibility,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.getFocusSetupVisibility =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetFocusSetupVisibility',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetFocusSetupVisibility);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse>}
 */
const methodDescriptor_FoodLogService_GetRecentMealsByTag = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetRecentMealsByTag',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest,
  proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.getRecentMealsByTag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetRecentMealsByTag',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetRecentMealsByTag,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.getRecentMealsByTag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/GetRecentMealsByTag',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_GetRecentMealsByTag);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest,
 *   !proto.com.livongo.protobuf.grpc.external.food.FoodLogs>}
 */
const methodDescriptor_FoodLogService_UpsertMealLog = new grpc.web.MethodDescriptor(
  '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpsertMealLog',
  grpc.web.MethodType.UNARY,
  proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest,
  proto.com.livongo.protobuf.grpc.external.food.FoodLogs,
  /**
   * @param {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.food.FoodLogs.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.livongo.protobuf.grpc.external.food.FoodLogs)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.food.FoodLogs>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServiceClient.prototype.upsertMealLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpsertMealLog',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_UpsertMealLog,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.food.FoodLogs>}
 *     Promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogServicePromiseClient.prototype.upsertMealLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.food.FoodLogService/UpsertMealLog',
      request,
      metadata || {},
      methodDescriptor_FoodLogService_UpsertMealLog);
};


module.exports = proto.com.livongo.protobuf.grpc.external.food;

